<template>
  <div style="display: flex;flex-direction: column;" >
    <div v-if="videoURL || webpURL" style="display: flex; gap: 10px;">
      <div v-if="videoURL">
        <div style="font-size: 12px; color: #666; margin-bottom: 5px;">原视频</div>
        <video :src="videoURL" alt="video" style="max-height:200px;max-width:200px;"  controls ></video>
      </div>
      <div v-if="webpURL">
        <div style="font-size: 12px; color: #666; margin-bottom: 5px;">转换后 (WebP)</div>
        <img :src="webpURL" alt="webp" style="max-height:200px;max-width:200px;" />
      </div>
    </div>
    <a-upload
      v-model:file-list="fileList"
      :show-upload-list="false"
      :customRequest="handleUpload"
      :before-upload="beforeUpload"
      accept="video/mp4"
    >
      <a-button style="margin: 10px;">
        <loading-outlined v-if="loadingImage"></loading-outlined>
        <plus-outlined v-else></plus-outlined>
        上传并转换视频
      </a-button>
    </a-upload>
  </div>
</template>
<script>
  
  import { defineComponent, reactive, ref } from 'vue'
  import request from '@/utils/request'
  import { Modal, message } from 'ant-design-vue';
  import OSS from 'ali-oss'
  import {
  LoadingOutlined, PlusOutlined,
} from '@ant-design/icons-vue';

  export default defineComponent({
    props: {
      videoURL: {
        type: String,
        default: '',
      },
      webpURL: {
        type: String,
        default: '',
      }
    },
    components: {
      LoadingOutlined,
      PlusOutlined,
    },
    data(){
      return {
        fileList: [],
        loadingImage: false,
        // imageUrl: '',
      }
    },
    mounted() {
      // this.imageUrl = this.modelValue
    },
    methods: {
      async handleUpload(file) {
        if (!file.file) {
            message.error("请选择文件")
            return
        }
        this.loadingImage = true

        try {
          // 第一步：上传视频到阿里云
          const sts = await request.post(`/api/aliyun/sts?image_type=upload`, {}, '上传中...')
          if (sts.error) {
            message.error(`存储服务授权失败:` + sts.error.message)
            this.loadingImage = false
            return
          }

          const client =  new OSS({
              accessKeyId: sts.data.sts_cert.AccessKeyId,
              accessKeySecret: sts.data.sts_cert.AccessKeySecret,
              stsToken: sts.data.sts_cert.SecurityToken,
              bucket: 'xuantupro',
              region: 'oss-cn-shanghai'
          });

          const name = `/${sts.data.bucket_path}/${sts.data.filename}.${file.file.type.split('/')[1]}`
          const result = await client.multipartUpload(name, file.file);

          var videoUrl = "http://statica.xuantu.pro"
          if (result && result.name) {
              videoUrl = videoUrl + result.name
          }

          // 发送视频 URL 给父组件
          this.$emit('update:videoURL', videoUrl)

          // 第二步：调用视频转换接口
          message.loading('正在转换视频...', 0)
          const convertResult = await request.post('/api/aliyun/video_convert', {
            video_url: videoUrl
          })
          message.destroy()

          if (convertResult.error) {
            message.error(`视频转换失败: ${convertResult.error.message}`)
            this.loadingImage = false
            return
          }

          // 第三步：解析并发送 webp_url
          if (convertResult.data && convertResult.data.webp_url) {
            this.$emit('update:webpURL', convertResult.data.webp_url)
            message.success('视频上传并转换成功')
          } else {
            message.warning('视频上传成功，但未获取到转换后的 URL')
          }

        } catch (error) {
          message.error(`操作失败: ${error.message}`)
        } finally {
          this.loadingImage = false
        }
      },
      beforeUpload(file) {
        console.log('beforeUpload', file)
        const isAllow = file.type === 'video/mp4';
        const isLtSize = file.size / 1024 / 1025 < 50;
        if (isAllow && !isLtSize) {
          message.error('视频需要小于 50MB');
          return false
        }
        return true;
      },
    },
  })
  </script>
  <style lang='scss' scoped>
  
  </style>